export default {
    name: 'Apple',
    dimensions: { width: 34, height: 40 },
    content: `
    <g clip-path="url(#clip0_12_1857)">
    <path d="M28.2649 21.2838C28.3291 27.3402 33.7435 29.3519 33.8077 29.3733C33.7649 29.5231 32.9516 32.241 30.9614 35.0658C29.2493 37.5055 27.4517 39.9238 24.6482 39.988C21.8875 40.0308 20.9887 38.4044 17.8428 38.4044C14.6755 38.4044 13.691 39.9452 11.0802 40.0308C8.36227 40.1378 6.28641 37.3985 4.55295 34.9802C0.97904 29.9939 -1.71745 20.92 1.92067 14.7994C3.71833 11.7605 6.94983 9.85586 10.4595 9.79166C13.1346 9.74886 15.6385 11.5251 17.265 11.5251C18.8914 11.5251 21.9517 9.38505 25.1618 9.68466C26.51 9.74886 30.2766 10.2197 32.7162 13.6438C32.5236 13.7936 28.2221 16.2119 28.2649 21.2838ZM23.0645 6.41036C24.4984 4.7197 25.4828 2.36563 25.2046 0.032959C23.1287 0.118562 20.6035 1.3812 19.1268 3.07185C17.8 4.5699 16.6229 6.96677 16.9439 9.25665C19.2552 9.42785 21.6307 8.10101 23.0645 6.41036Z" fill="currentColor"/>
    </g>
    <defs>
    <clipPath id="clip0_12_1857">
    <rect width="33.6158" height="40.0009" fill="currentColor" transform="translate(0.191895 0.032959)"/>
    </clipPath>
    </defs>
    `
};
